import ListingDetailRichContent from './ListingDetailRichContent'

export default ListingDetailRichContent
